<template>
  <div ref="listWrap">
    <div class="widget">
      <div class="whead" v-if="queryParam.query_EQ_paasTreeParentId==='root'">
        <div class="whead-left">
          <span>根节点列表</span>
        </div>
        <div class="whead-right">
          <mButton type="lightBlue" icon="md-add" size="s" @click="paasAddChildNode">添加分类</mButton>
        </div>
      </div>
      <div class="whead" v-else>
        <div class="whead-left">
          <span style="color: #559cc7">{{paasTreeParentName}}</span>
          <span style="font-size: 12px">子节点列表</span>
        </div>
        <div class="whead-right">
          <mButton type="lightBlue" icon="md-add" size="s" @click="paasAddChildNode">添加分类</mButton>
        </div>
      </div>
      <div class="body tableWrap" >
        <Table :columns="tableColumns"
               :data="tableData"
               :height="tableHeight"
               stripe border draggable
               @on-drag-drop="dropNode"></Table>
      </div>
    </div>
  </div>
</template>

<script>
  import Widget from '@components/paas/widget'
  import metaTreeList from "@assets/js/list/meta-tree-list.js";
  import CellBar from '@components/paas/cell-bar' //列表内操作
  import mButton from '@components/button/m-button';
  export default {
    name: "list",
    mixins:[metaTreeList],
    components:{Widget,CellBar,mButton},
    data(){
      return{
        serviceUrl:"/sys/image/category", //后台访问路径，必须
        currentIdFiledName:"id",
        queryParam:{
          query_EQ_parentId:'',
          queryOrderBy_: 'displayOrder@asc',
        },
        tableColumns:[
          {
            title:'图片分类名称',
            key:'title',
            align:'center'
          },
          {
            title:'父节点名称',
            key:'parentName',
            align:'center'
          },
          {
            title:'排序',
            key:'displayOrder',
            align:'center'
          },
          {
            title:'操作',
            align:'center',
            width:200,
            render:(h,params)=>{
              return h(CellBar,{
                props:{
                  show:"icon",
                },
                on: {
                  /**
                   * 修改节点
                   */
                  'treeEditNode': ()=> {
                    let paasTreeParentId = this.$route.query[this.currentIdFiledName];
                    if(!paasTreeParentId || typeof(paasTreeParentId) === "undefined"){
                      paasTreeParentId = "root";
                    }
                    this.$nextTick(()=>{
                      this.paasAddChildNode(event,this.serviceUrl+"/edit?"+this.currentIdFiledName+"="+params.row[this.currentIdFiledName]+"&parentId="+ paasTreeParentId);
                    })
                  },
                  'treeDeleteNode':()=>{
                    /**
                     * 删除节点以及节点下所有子节点
                     */
                    this.$nextTick(()=>{
                      this.deleteTreeNode(params);
                    })
                  },
                  'treeDetailNode':()=>{
                    this.$nextTick(()=>{
                      this.paasDetailOper(params.row[this.currentIdFiledName]);
                    })
                  },
                }
              })
            }
          },
        ]
      }
    },
    methods:{
      saveOnShowData(row){
        this.axios.post(this.$store.state.sysApi+this.serviceUrl+"/saveOnShowData?isShow="+row.isShow+"&storeCategoryId="+row.storeCategoryId).then(res => {
          if(res.code === 200) {
            this.$Message.info('数据更新成功！');
          }
        }).catch(function(error){
          this.$Message.error('数据更新失败！');
        });
      }
    }
  }
</script>

<style scoped>
  .widget {
    background: #f7f7f7;
    border:none;
    box-shadow: none;
    position: relative;
  }
  .whead {
    height: 38px;
    color: #636363;
    background: #f8f8f8;
    background: -webkit-gradient(linear, left top, left bottom, from(#f8f8f8),to(#e8e8e8));
    background: linear-gradient(to bottom, #f8f8f8 0%,#e8e8e8 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f8f8f8', endColorstr='#e8e8e8',GradientType=0 );

  }
  .widget > [class*="whead"]{
    border: 1px solid #cdcdcd;
    box-shadow: 0 1px 0 #fff;
    -webkit-box-shadow: 0 1px 0 #fff;
    -moz-box-shadow: 0 1px 0 #fff;
    text-shadow: 0 1px #fff;
    -webkit-border-top-right-radius: 3px;
    -webkit-border-top-left-radius: 3px;
    -moz-border-radius-topright: 3px;
    -moz-border-radius-topleft: 3px;
    position: relative;
  }
  .widget > [class*="whead"] .whead-left{
    float: left;
    padding: 8px 14px 7px 14px;
    font-size: 14px;
    font-weight: bold;
  }
  .widget > [class*="whead"] .whead-left span{
    letter-spacing: 1px;
  }
  .widget .body{
    padding:0px;
    border-left: 1px solid #cdcdcd;
  }
  .widget > [class*="whead"] .whead-right{
    float: right;
    padding: 5px 14px 4px 14px;
  }
  .tableWrap >>> .ivu-table th {
    font-weight: bold;
    height: 30px;
    background: #eee;
    padding: 3px 18px 2px 10px;
    color: #909090;
    cursor: pointer;
    *cursor: hand;
    font-size: 13px;
    box-shadow: 0 1px 0px #fff inset;
    -webkit-box-shadow: 0 1px 0px #fff inset;
    -moz-box-shadow: 0 1px 0px #fff inset;
  }
  .tableWrap >>> .ivu-table td{
    padding: 4px 11px;
    height: auto;
  }
  .tableWrap >>>  .ivu-table-wrapper .ivu-table-stripe .ivu-table-body tr:nth-child(2n+1) td,
  .tableWrap >>>  .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n+1) td{
    background-color: #f7f7f7;
  }
  .ivu-table-wrapper .ivu-table-stripe .ivu-table-body tr:nth-child(2n) td,
  .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td{
    background-color: #f2f2f2;
  }
  .tableWrap >>>.ivu-table-wrapper{
    border:none;
  }
  .tableWrap >>> .ivu-table .ivu-table-cell{
    padding:0px;
  }
</style>
